import { Button as AriaButton } from 'react-aria-components';
import { useLingui } from '@lingui/react/macro';

import IconCross from '@/icons/Cross.svg';
import { createBEMClasses } from '@/utils/classname';

import './Box.css';

const { block, element } = createBEMClasses('box');

interface BoxProps {
  className?: string;
  width?: string;
  padding?: string;
  gap?: React.CSSProperties['gap'];
  alignItems?: React.CSSProperties['alignItems'];
  justifyContent?: React.CSSProperties['justifyContent'];
  flexWrap?: React.CSSProperties['flexWrap'];
  onClose?: () => void;
  ariaLabel?: string;
  removeStyleOnMobile?: boolean;
  removeStyleOnTablet?: boolean;
  children: React.ReactNode;
  role?: string;
  style?: React.CSSProperties;
}

const Box = ({
  className,
  width,
  padding = '16px',
  gap,
  alignItems,
  justifyContent,
  flexWrap,
  onClose,
  ariaLabel,
  removeStyleOnMobile,
  removeStyleOnTablet,
  children,
  role,
  style,
}: BoxProps) => {
  const { t } = useLingui();

  return (
    <div
      className={block(
        {
          'remove-style-on-mobile': removeStyleOnMobile,
          'remove-style-on-tablet': removeStyleOnTablet,
        },
        className
      )}
      style={{ width, padding, gap, alignItems, justifyContent, flexWrap, ...style }}
      aria-label={ariaLabel}
      role={role}
    >
      {onClose && (
        <AriaButton
          className={element('close')}
          onPress={onClose}
          aria-label={t({ id: 'design-system.box.close', message: 'Close' })}
        >
          <IconCross />
        </AriaButton>
      )}
      {children}
    </div>
  );
};

export default Box;
